<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/permisos">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Permisos Retribuidos y Ausencias</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <!-- <h1>Ver {{ permiso }}</h1> -->
                        <h1>Ver</h1>
                    </div>
                    <div id="Detail" class="detail-Generalleave">
                        <div class="row">
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Fecha desde</label>
                                <!-- <p>{{ formatDate(permiso.fechaDesde) }} {{formatHorasMinutos(permiso.horaDesde)}}</p> -->
                                <p>{{ formatDate(permiso.fechaDesde) }} {{ permiso.horaDesde }}</p>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Fecha hasta</label>
                                <!-- <p>{{ formatDate(permiso.fechaHasta) }} {{formatHorasMinutos(permiso.horaHasta)}}</p> -->
                                <p>{{ formatDate(permiso.fechaHasta) }} {{ permiso.horaHasta }}</p>
                            </div> 
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Número de días</label>
                                <p>{{ permiso.numDias }}</p>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Número de horas</label>
                                <p>{{ permiso.numHoras }}</p>
                            </div>
                        </div>
                        
                        <hr />
                        
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <label for="">Estado</label>
                                <p>{{ permiso.estado }}</p>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <label for="">Tipo de permiso</label>
                                <p>{{ descripcionTipoPermiso }}</p>
                            </div>
                        </div>
                        
                        <hr />
                        
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <label for="">Observaciones</label>
                                <p>{{ permiso.observaciones }}</p>
                            </div>
                        </div>
                        <hr />
                        <div class="form-group">
                            <label for="">Adjunto/s</label>
                                <div v-if="permiso.adjunto_1 && permiso.adjunto_1!='null'" id="div_adjunto_1">
                                    <a href="javascript:void(0);" @click="descargarAdjunto(permiso.adjunto_1)" title="haz click para descargar...">
                                        {{ permiso.adjunto_1 }}
                                    </a>
                                </div>
                                <div v-if="permiso.adjunto_2 && permiso.adjunto_2!='null'" id="div_adjunto_2">
                                    <a href="javascript:void(0);" @click="descargarAdjunto(permiso.adjunto_2)" title="haz click para descargar...">
                                        {{ permiso.adjunto_2 }}
                                    </a>
                                </div>
                                <div v-if="permiso.adjunto_3 && permiso.adjunto_3!='null'" id="div_adjunto_3">
                                    <a href="javascript:void(0);" @click="descargarAdjunto(permiso.adjunto_3)" title="haz click para descargar...">
                                        {{ permiso.adjunto_3 }}
                                    </a>
                                </div>
                            <p></p>
                        </div>
                        <hr />
                        <div class="form-group">
                            <!-- <label for="">Tramites: {{ permisosTramites }}</label> -->
                            <label for="">Tramites:</label>
                            <ul class="listaTramites" v-for="(permisoTramites, index) in permisosTramites">
                                <li>
                                    <strong>
                                       <u>Tramite {{ permisosTramites.length - index }}</u>: {{ formatDate(permisoTramites.fecha) }} / {{ permisoTramites.estado }}
                                    </strong>
                                </li>
                                <div>
                                    <i>
                                        {{ permisoTramites.observacionesRRHH }}
                                    </i>
                                </div>
                            </ul>
                        </div>
                    </div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "DetallePermiso",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		computed:{
            permisos: function(){
				let permisos = this.$store.state.perfil.permisos || [];
			
                return (Array.isArray(permisos))? permisos : [permisos];
			},
			permiso: function(){
                let permiso = null;

				if (this.permisos.length > 0){
                    permiso = this.permisos.find(permiso=>{
                        return permiso.id == this.$route.params.id_permiso;
                    });
				}

                return permiso;
        
			},
            descripcionTipoPermiso: function(){
                let tipoAusencia = {};
                let tiposAusencia = this.$store.state.perfil.tiposAusencia || [];
                let id_tipoAusencia = this.permiso.id_tipoAusencia;

                tiposAusencia = (Array.isArray(tiposAusencia))?tiposAusencia:[tiposAusencia];
                
                tipoAusencia = tiposAusencia.find(function(tipoausencia){
                    return tipoausencia.id == id_tipoAusencia;
                })

                return tipoAusencia.nombre;
            },
            permisosTramites: function(){
                const tramites = this.permiso.tramites || [];
                
                return (Array.isArray(tramites))? tramites: [tramites];
            }            
		},
        methods:{
            formatDate: function (date) {
				return this.moment(date).format('DD/MM/YYYY');
			},
            formatHorasMinutos: function (hm){
                //return `${parseInt(hm / 100)}:${`0${hm % 100}`.slice(-2)}`;

                return this.moment(`0000${hm}`.slice(-4), 'HH:mm').format('HH:mm');
            },
            descargarAdjunto: function(adjunto){
                // console.log(adjunto);
                this.$store.dispatch("descargarAdjunto", {
                    adjunto: adjunto,
                    categoria: 'permisos',
                    id: this.permiso.id
                });
            }
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
